import { Subject } from 'rxjs/Rx';
import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable()
export class ProcessListener {
  public subject = new Subject();
  @Output() onAddDownloadProcess: EventEmitter<any> = new EventEmitter();
  @Output() onRemoveDownloadProcess: EventEmitter<any> = new EventEmitter();
}
export const process = new ProcessListener();



// WEBPACK FOOTER //
// ./src/app/components/process/process.listener.ts